/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createAwardRequest } from '../models/api_createAwardRequest';
import type { api_createAwardResponse } from '../models/api_createAwardResponse';
import type { api_updateAwardBudgetMarshallRequest } from '../models/api_updateAwardBudgetMarshallRequest';
import type { api_updateAwardBudgetRequest } from '../models/api_updateAwardBudgetRequest';
import type { api_updateAwardRequest } from '../models/api_updateAwardRequest';
import type { db_GetAwardRow } from '../models/db_GetAwardRow';
import type { db_GetAwardSignatureRow } from '../models/db_GetAwardSignatureRow';
import type { db_ListAwardsPublicRow } from '../models/db_ListAwardsPublicRow';
import type { db_ListAwardsRow } from '../models/db_ListAwardsRow';
import type { db_ListAwardStipendsByAwardIDRow } from '../models/db_ListAwardStipendsByAwardIDRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Awards {
    /**
     * Get a list of awards (admin)
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListAwardsRow OK
     * @throws ApiError
     */
    public static listAwards(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListAwardsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/awards',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create an award
     * @param body Award details
     * @returns api_createAwardResponse Created
     * @throws ApiError
     */
    public static createAward(
        body: api_createAwardRequest,
    ): CancelablePromise<api_createAwardResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/awards',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of awards (public)
     * @param awardIds Award IDs
     * @param programmeCode Programme code
     * @param countryId Country ID
     * @returns db_ListAwardsPublicRow OK
     * @throws ApiError
     */
    public static listAwardsPublic(
        awardIds?: string,
        programmeCode?: string,
        countryId?: string,
    ): CancelablePromise<Array<db_ListAwardsPublicRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/awards/public',
            query: {
                'award_ids': awardIds,
                'programme_code': programmeCode,
                'country_id': countryId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an award record
     * @param id Award ID
     * @returns db_GetAwardRow OK
     * @throws ApiError
     */
    public static getAward(
        id: number,
    ): CancelablePromise<db_GetAwardRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/awards/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an award record
     * @param id Award ID
     * @param body Award details
     * @returns void
     * @throws ApiError
     */
    public static updateAward(
        id: number,
        body: api_updateAwardRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/awards/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an award's base unit costs
     * @param id Award ID
     * @param body Award budget details
     * @returns void
     * @throws ApiError
     */
    public static updateAwardBudget(
        id: number,
        body: api_updateAwardBudgetRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/awards/{id}/budget',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an award's base unit costs (Marshall)
     * @param id Award ID
     * @param body Award budget details
     * @returns void
     * @throws ApiError
     */
    public static updateAwardBudgetMarshall(
        id: number,
        body: api_updateAwardBudgetMarshallRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/awards/{id}/budget-marshall',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an award letterhead document
     * @param id Award ID
     * @returns binary OK
     * @throws ApiError
     */
    public static getAwardLetterheadDocument(
        id: number,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/awards/{id}/letterhead',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an award letterhead record
     * @param id Award ID
     * @param letterheadDocument Letterhead file
     * @returns void
     * @throws ApiError
     */
    public static updateAwardLetterhead(
        id: number,
        letterheadDocument: Blob,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/awards/{id}/letterhead',
            path: {
                'id': id,
            },
            formData: {
                'letterhead_document': letterheadDocument,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of award signatures
     * @param id Award ID
     * @returns db_GetAwardSignatureRow OK
     * @throws ApiError
     */
    public static getAwardSignatures(
        id: number,
    ): CancelablePromise<Array<db_GetAwardSignatureRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/awards/{id}/signatures',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new award signature
     * @param id Award ID
     * @param awardSignatureTypeId
     * @param email
     * @param position
     * @param signatureName
     * @param signatureDocument Signature file
     * @returns any Created
     * @throws ApiError
     */
    public static createAwardSignature(
        id: number,
        awardSignatureTypeId: number,
        email: string,
        position: string,
        signatureName: string,
        signatureDocument?: Blob,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/awards/{id}/signatures',
            path: {
                'id': id,
            },
            formData: {
                'signature_document': signatureDocument,
                'award_signature_type_id': awardSignatureTypeId,
                'email': email,
                'position': position,
                'signature_name': signatureName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an award signature document
     * @param id Award ID
     * @param awardSignatureId Award signature ID
     * @returns binary OK
     * @throws ApiError
     */
    public static getAwardSignatureDocument(
        id: number,
        awardSignatureId: number,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/awards/{id}/signatures/{award_signature_id}/document',
            path: {
                'id': id,
                'award_signature_id': awardSignatureId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of stipends for an award
     * @param id Award ID
     * @returns db_ListAwardStipendsByAwardIDRow OK
     * @throws ApiError
     */
    public static listAwardStipends(
        id: number,
    ): CancelablePromise<Array<db_ListAwardStipendsByAwardIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/awards/{id}/stipends',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
